import type {
  MetadataValidationResult,
  MetadataValidationResultV0,
} from 'schemas/types';
import {getValidationPrPart} from 'schema/form/functions/validators';

export const getMetadataValidationPrPart = (
  validation: MetadataValidationResult,
): MetadataValidationResultV0 => {
  const expression = validation.expressions?.[0];
  const manifestation = expression?.manifestations?.[0];

  return {
    ...validation,
    work: getValidationPrPart(validation.work),
    expression: getValidationPrPart(
      expression ? expression.validation : undefined,
    ),
    manifestation: getValidationPrPart(
      manifestation ? manifestation.validation : undefined,
    ),
  };
};
